export const aciEmegencyContact = {
    iconName: 'emegency-contact',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 18' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M7.2 8.4a1.2 1.2 0 11-2.4-.001 1.2 1.2 0 012.4 0zM8 12.796H4v-.798a1.2 1.2 0 011.2-1.2h1.6a1.2 1.2 0 011.2 1.2v.799z',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                },
            },
            {
                attr: {
                    d: 'M21.026 0H2.474A2.481 2.481 0 000 2.474V15.09a2.48 2.48 0 002.474 2.473h18.552A2.48 2.48 0 0023.5 15.09V2.474A2.48 2.48 0 0021.026 0zM2.474 1.237h18.552c.743 0 1.237.495 1.237 1.237v1.979H1.237v-1.98c0-.741.495-1.236 1.237-1.236zm18.552 15.09H2.474c-.742 0-1.237-.495-1.237-1.237v-9.4h21.026v9.4c0 .742-.494 1.236-1.237 1.236z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M19.782 9h-8.164c-.37 0-.618.247-.618.618s.247.619.618.619h8.164c.37 0 .618-.248.618-.619 0-.37-.247-.618-.618-.618zM16.813 11.969h-5.195c-.37 0-.618.247-.618.618s.247.619.618.619h5.195c.371 0 .619-.248.619-.619 0-.37-.248-.618-.619-.618z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
